import {Injectable} from '@angular/core';
import {Product} from "../model/product";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {DocumentFolder} from "../model/documentFolder";
import {DocumentFile} from "../model/document-file";

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private httpClient: HttpClient) {}

  /**
   * Retrieves all document folders for a specific document id
   *
   * @param documentId Id of the document for which all folders should be retrieved
   * @param options HttpOptions
   * @return Observable containing an array of all retrieved document folders
   */
  public getDocumentFoldersByDocumentId(documentId: string, options = {}): Observable<DocumentFolder[]>{
    const url = `/api/documents/${documentId}/folders`;
    return this.httpClient.get<DocumentFolder[]>(url, options);
  }

  /**
   * Retrieves all document files for a specific document id
   *
   * @param documentId Id of the document for which all folders should be retrieved
   * @param options HttpOptions
   * @return Observable containing an array of all retrieved document files
   */
  public getDocumentFilesByDocumentId(documentId: string, options = {}): Observable<DocumentFile[]>{
    const url = `/api/documents/${documentId}/files`;
    return this.httpClient.get<DocumentFile[]>(url, options);
  }


  getFullName(shortName, products: Product[]) {
    let product: Product = products.find(obj => obj.nameShort === shortName);
    if(!product){
      return shortName;
    }
    return product.name_long;
  }

}
